module.exports = __webpack_public_path__ + "media/images/lp-main-girl-tel-a58c57003a458640dbb829f8257ad9bc.jpg";